import LayoutNode from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { GeneratePublishHTMLString } from "../GeneratePublishHTMLString";
import WebDesigner from "../WebDesigner";
import generateGlobalStyleFromSiteData from "vagaro-website-rendering/src/components/Utilities/GenerateGlobalStyleFromSiteData";
import { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import { CDNResolutions } from "vagaro-website-rendering/src/components/Utilities/GetImageURLWithResolution";
import React from "react";

export  function GetNodeDomBounds({root,designer,callBack}:{root:LayoutNode,designer:WebDesigner,callBack?:Function}){

    const publishString = GeneratePublishHTMLString(root,designer.props.siteData,false,false);
    const [screenSize,setScreenSize] = useState<ScreenSize>(ScreenSize.Desktop);
    const rootRef = useRef<HTMLDivElement>(null);


    useEffect(()=>{

        //check if it is a synced component since that component is empty until bound (for now maybe always set the image to full size)

        if(rootRef.current){

            let doms = rootRef.current.querySelectorAll(".hierarchy");
          
            
            for(let i = 0;i<doms.length;i++){
                    
                    let dom = doms[i];
                
                  
                    let newID = dom.id.substring(1);

                    let res = "x";
                    let node = designer.getLayoutNodeById(newID);
                    if(node){
                      
                        let bounds = dom.getBoundingClientRect();

                        if(dom.classList.contains("vb-control")){
                            res = CDNResolutions.Large;
                        }
                        else if(bounds.width<300&&bounds.height<300){
                         res = CDNResolutions.Medium;
                         }
                 
                        else if(bounds.width<1200&&bounds.height<1200){
                            res = CDNResolutions.Large;
                        }
                        else{
                            res = "";//super big, use original
                        }

                        if(res!=node.screenResolutions){
                            if(res!="x"){
                                if(node.screenResolutions === CDNResolutions.Large && res===CDNResolutions.Medium){
                                    
                                }
                                else{
                   
                                    node.screenResolutions = res;
                                }

                            }

                        }

                       
                    }
            }

        }

        if(screenSize===ScreenSize.Desktop){
            setScreenSize(ScreenSize.Tablet);
        }
        else if(screenSize===ScreenSize.Tablet){
            setScreenSize(ScreenSize.Mobile);
        }

        else{
            let dom = rootRef.current?.parentElement;
            if(dom)
            ReactDOM.unmountComponentAtNode(dom);

            callBack&&callBack();
        }
          // eslint-disable-next-line
    },[screenSize])


    let breakClass = "screen-desktop";
    if(screenSize === ScreenSize.Tablet){
        breakClass = "tablet-break  screen-tablet";

    }
    if(screenSize === ScreenSize.Mobile){
        breakClass = "screen-mobile  tablet-break mobile-break";
    }

    return <>
    <style>{generateGlobalStyleFromSiteData(designer.props.siteData.siteStyling,undefined,false)}</style>
    <div  
        className={"v-site render  " +breakClass}
        style={{minWidth:"1600px",height:"auto",position:"fixed",zIndex:1000000}}
        dangerouslySetInnerHTML={{__html:publishString}}
        ref={rootRef}
    >
        
    </div></>

}




export default async function SetNodeDomBoundsAsync(root:LayoutNode,designer:WebDesigner):Promise<void>{

    //reset resolutions
        //ProcessNodes(root,(node)=>{ node.screenResolutions = "" });

        return new Promise((resolve,reject)=>{
            let dom = document.getElementById("OpenDialog1");
            if(!dom){
            
                reject();
            }

            ReactDOM.render(
            <GetNodeDomBounds root={root} designer={designer} callBack={()=>{resolve()}}/> ,dom);

        })

}

